import { deleteBucketFile } from 'api/canpark/bucket/deleteFile';
import { TicketAttachment } from '../types/ticket';

const SCAN_SOURCE = 'license-plate-scan';
const SCAN_NAME_PREFIX = 'license_plate_scan_';

const dataUrlToFile = (dataUrl: string, fileName: string): File => {
	const [, base64] = dataUrl.split(',');
	const bytes = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
	return new File([bytes], fileName, { type: 'image/jpeg' });
};

export const attachLicensePlateScan = async (
	croppedImage: string,
	uppy: any,
	attachments: TicketAttachment[],
	setAttachments: (attachments: TicketAttachment[]) => void,
): Promise<void> => {
	if (!uppy) return;

	uppy.getFiles().forEach((file: any) => {
		if (file?.meta?.source === SCAN_SOURCE) {
			uppy.removeFile(file.id);
		}
	});

	const priorScanAttachments = attachments.filter((a) =>
		a.Name.startsWith(SCAN_NAME_PREFIX),
	);
	if (priorScanAttachments.length > 0) {
		await Promise.all(
			priorScanAttachments.map((a) =>
				deleteBucketFile(a.AttachmentID).catch((err) => {
					console.warn(
						'[attachLicensePlateScan] Failed to delete prior scan attachment',
						a.AttachmentID,
						err,
					);
				}),
			),
		);
		setAttachments(
			attachments.filter((a) => !a.Name.startsWith(SCAN_NAME_PREFIX)),
		);
	}

	const name = `${SCAN_NAME_PREFIX}${Date.now()}.jpg`;
	const file = dataUrlToFile(croppedImage, name);

	uppy.addFile({
		name,
		type: 'image/jpeg',
		data: file,
		source: SCAN_SOURCE,
		meta: { source: SCAN_SOURCE, relativePath: name },
	});

	await uppy.upload();
};
